<template>
  <v-layout>
    <d-container>
      <d-header>
        <h1 class="title">
          {{ $t('account_parameters') }}
        </h1>
      </d-header>
    </d-container>
    <v-form-info :user="user" />
    <v-form-password :user="user" />
  </v-layout>
</template>

<script>
import formInfo from "./form-info.vue";
import formPassword from "./form-password.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("account_parameters").capitalize()
    };
  },
  components: {
    "v-form-info": formInfo,
    "v-form-password": formPassword,
  },
  data () {
    return {
      user: this.$laravel.user
    };
  }
};
</script>
